<div class="main-content">
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
        <div class="container-fluid">
            <a class="navbar-brand" [routerLink]="['/home']">
                <img src="assets/img1.png" alt="" width="30" height="24" class="d-inline-block align-text-top">
                toDoList</a>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarScroll"
                aria-controls="navbarScroll" aria-expanded="false" aria-label="Toggle navigation">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse main" id="navbarScroll">
                <ul class=" navbar-nav mt-2  ml-auto" style="--bs-scroll-height: 100px;">
                    <li class="nav-item">
                        <a class="nav-link" [routerLink]="['/login']">Login</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" [routerLink]="['/signup']">Sign up</a>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
    <div class="progress">
        <div class="progress-bar  progress-bar-striped bg-success" role="progressbar" [style.width]="resultPercentage"
            aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
    </div>
    <div class="container">
        <div class="form-content">
            <form [formGroup]="profileSignupForm" (ngSubmit)="signUpFunction(profileSignupForm)">
                <div class="form-heading">
                    Sign up
                </div>
                <div class="form-group">
                    <label for="firstNameInput">First Name</label>
                    <input type="text" class="form-control" [ngClass]="{
                        'has-danger': ((profileSignupForm.get('userFirstName').invalid && profileSignupForm.get('userFirstName').dirty)||(profileSignupForm.get('userFirstName').touched && profileSignupForm.get('userFirstName').pristine)), 
                        'has-success': profileSignupForm.get('userFirstName').valid && profileSignupForm.get('userFirstName').dirty
                      }" id="firstNameInput" placeholder="Enter your First Name" autocomplete="username"
                        formControlName="userFirstName" data-toggle="tooltip" title="Max 30 characters"
                        (change)="updateProgressBar()">
                    <br />
                    <label for="secondNameInput" class="right-inline">Last Name</label>
                    <input type="text" class="form-control" [ngClass]="{
                        'has-danger': ((profileSignupForm.get('userLastName').invalid)), 
                        'has-success': profileSignupForm.get('userLastName').valid && profileSignupForm.get('userLastName').dirty
                      }" id="secondNameInput" placeholder="Enter your Last Name" autocomplete="username"
                        formControlName="userLastName" data-toggle="tooltip" title="Max 30 characters, Optional">
                </div>
                <div class="form-group">
                    <label id="mobileNumberLabel" for="mobileNumberInput">Mobile Number</label>
                    <input type="text" class="form-control" [ngClass]="{
                        'has-danger': ((profileSignupForm.get('userMobileNumber').invalid && profileSignupForm.get('userMobileNumber').dirty)||(profileSignupForm.get('userMobileNumber').touched && profileSignupForm.get('userMobileNumber').pristine)),
                        'has-success': profileSignupForm.get('userMobileNumber').valid && profileSignupForm.get('userMobileNumber').dirty
                      }" id="mobileNumberInput" placeholder="Enter your mobile number"
                        formControlName="userMobileNumber" data-toggle="tooltip" title="Enter without country code"
                        (change)="updateProgressBar()">
                    <br />
                    <label for="countryInput" class="right-inline">Country</label>
                    <select id="countryInput" class="form-control" size="3" aria-label="size 3 select example"
                        [ngClass]="{
                        'has-danger': ((profileSignupForm.get('userCountry').invalid && profileSignupForm.get('userCountry').dirty)||(profileSignupForm.get('userCountry').touched && profileSignupForm.get('userMobileNumber').pristine)),
                        'has-success': profileSignupForm.get('userCountry').valid && profileSignupForm.get('userCountry').dirty
                      }" formControlName="userCountry" (change)="updateProgressBar()">
                        <option *ngFor="let country of countryList" [value]="country">{{country}}</option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="mailInput">Email</label>
                    <input type="email" class="form-control" [ngClass]="{
                        'has-danger': ((profileSignupForm.get('userMail').invalid && profileSignupForm.get('userMail').dirty)||(profileSignupForm.get('userMail').touched && profileSignupForm.get('userMail').pristine)), 
                        'has-success': profileSignupForm.get('userMail').valid && profileSignupForm.get('userMail').dirty
                      }" id="mailInput" placeholder="Enter your mail Id" formControlName="userMail"
                        (change)="updateProgressBar()">
                </div>
                <div class="form-group">
                    <label for="passwordInput">Password</label>
                    <input type="password" class="form-control" [ngClass]="{
                        'has-danger': ((profileSignupForm.get('userPassword').invalid && profileSignupForm.get('userPassword').dirty)||(profileSignupForm.get('userPassword').touched && profileSignupForm.get('userPassword').pristine)), 
                        'has-success': profileSignupForm.get('userPassword').valid && profileSignupForm.get('userPassword').dirty
                      }" id="passwordInput" placeholder="Enter your password" formControlName="userPassword"
                        data-toggle="tooltip" title="Minimum 8, Maximum 30 characters, atleast 1 number, 1
                        uppercase and 1 lowercase letter" (change)="verify()" (change)="updateProgressBar()">
                </div>
                <div class="form-group">
                    <label id="confirmPassword" for="confirmPasswordInput">Confirm Password</label>
                    <input type="password" class="form-control" [ngClass]="{
                        'has-danger': ((profileSignupForm.get('userConfirmPassword').invalid && profileSignupForm.get('userConfirmPassword').dirty)||(profileSignupForm.get('userConfirmPassword').touched && profileSignupForm.get('userConfirmPassword').pristine))||(!result && profileSignupForm.get('userConfirmPassword').dirty), 
                        'has-success': profileSignupForm.get('userConfirmPassword').valid && profileSignupForm.get('userConfirmPassword').dirty && result
                      }" id="confirmPasswordInput" placeholder="Enter your password again" data-toggle="tooltip"
                        title="Passwords have to match" formControlName="userConfirmPassword" (change)="verify()"
                        (change)="updateProgressBar()">
                </div>
                <div class="form-group">
                    <button type="submit" class="btn btn-success btn-lg d-grid gap-2 col-sm-4 mx-auto"
                        [disabled]="(!profileSignupForm.valid || !result) || (profileSignupForm.valid && !result) ">Submit</button>


                    <button type="submit" class="btn btn-danger btn-lg d-grid gap-2 col-sm-4 mx-auto"
                        (click)="resetSignUpForm()">Reset</button>

                </div>

            </form>
        </div>
    </div>
</div>